/** Mirrors com.viztrend.integration.admin.model.FormList. */
export interface FormList {
  id: number;
  name: string;
  hasZip: boolean;
}

/** Mirrors com.viztrend.integration.admin.model.Form. */
export interface AdminForm {
  identifier: string;
  name: string | null;
  includeLocationHierarchy: boolean;
}

/** Mirrors com.viztrend.integration.admin.model.LocationHierarchy. */
export interface AdminLocationHierarchy {
  id: number;
  name: string;
  xml?: string | null;
  location1: string | null;
  location2: string | null;
  location3: string | null;
  location4: string | null;
  /** Populated lazily by /json/admin/loadLocations/{id}; not sent by the server. */
  locations?: LocationNode[];
}

/** Mirrors com.viztrend.integration.admin.model.Node. */
export interface LocationNode {
  key: string;
  title: string;
  parent: string;
  level: string;
  children?: LocationNode[];
}

/** Mirrors com.viztrend.integration.admin.model.AccessLogItem. */
export interface AccessLogItem {
  id: number;
  date: string;
  description: string | null;
  userId: number;
  userName: string | null;
  questionnaireidentifier: string | null;
  questionnaireName: string | null;
}

/** Mirrors com.viztrend.integration.admin.model.ActivityModel. */
export interface ActivityItem {
  userId: number;
  count: number;
  week: number;
  month: number;
  year: number;
}

export type ActivityPeriod = 'week' | 'month' | 'year';

/** Response of GET /json/admin/getUserStats. */
export interface UserStats {
  activeUsers: number;
  noOfOfficeUsers: number;
  maxUsers: number;
  pricingPlan?: string;
}

/** Response of GET /json/admin/get/template. */
export interface InviteTemplate {
  email_template: string | null;
  email_template_google: string | null;
  default_email_template: string | null;
  email_template_subject: string | null;
}

/** Free-form on the server; these are the two values the seat rules branch on. */
export type PricingPlan = string;

export const PRICING_PER_TRANSACTION = 'Per Transaction';
export const PRICING_PER_USER = 'Per User';

/**
 *  Account-level context. Merges the POST /json/admin/init response with the
 *  session values the JSP currently writes onto window in admin.tmpl.jsp.
 */
export interface AdminAccountState {
  loaded: boolean;

  // from /json/admin/init
  responsible_user: boolean;
  contactEmail: string | null;
  transcriptionUsage: number;
  transcriptionUsageUnits: string | null;
  transcriptionBudget: number;
  transcriptionBudgetUnits: string | null;
  aiCredits: number;
  aiUsage: number;

  // seats, refreshed by /json/admin/getUserStats
  activeUsers: number;
  officeUsers: number;
  maxUsers: number;
  monthlyLicences: number;
  pricingPlan: PricingPlan | null;
  paymentSchedule: string | null;
  maxPasswordAge: number;

  // session context
  groupId: number | null;
  userId: number | null;
  hasSuperUserGroup: boolean;
  superUserGroup: boolean;
  hasOrganization: boolean;
  isOrganization: boolean;
  samlIdpMetadata: boolean;
  /** Account is allowed to use SAML sign-in at all. */
  samlEnabled: boolean;
  /** Account exposes the "access shared data only" option on a user. */
  accessSharedDataOnlyEnabled: boolean;
  adminDisablePassword: boolean;
  /** Earliest access-log date; the origin of the Activity view's period columns. */
  logDate: string | null;
  db: string | null;
}
